// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_1uS17","container":"index_container_3_dv3","googleSign":"index_googleSign_2pFYd","footerNav":"index_footerNav_1iCWR"};